import { Typography } from "@mui/material";
import { styled, useTheme } from "@mui/material";
import { FC } from "react";

interface StateInfoGuideProps {
  image?: string;
  title: string;
  description: string;
  guideText: string;
  linkText?: string;
  linkUrl?: string;
}

export const StateInfoGuide: FC<StateInfoGuideProps> = ({
  image,
  title,
  description,
  guideText,
  linkText,
  linkUrl,
}) => {
  const theme = useTheme();

  return (
    <ContentContainer sx={{ height: "500px" }}>
      {image && (
        <ImageContainer>
          <StyledImage src={image} alt="title image" />
        </ImageContainer>
      )}
      <Typography variant="h5" component="h2" fontWeight="600" marginTop="1rem" marginBottom="1rem">
        {title}
      </Typography>

      <Typography variant="body1" marginTop="0" marginBottom="1rem" maxWidth="40rem">
        {description}
      </Typography>

      <Typography variant="body1" marginTop="0" marginBottom="1rem">
        {guideText}
      </Typography>

      {linkText && linkUrl && (
        <Typography variant="body1" marginTop="0" marginBottom="0">
          For more information, see{" "}
          <a
            href={linkUrl}
            style={{ color: theme.palette.hyperLink.textColor }}
            target="_blank"
            rel="noopener noreferrer"
          >
            {linkText}
          </a>
        </Typography>
      )}
    </ContentContainer>
  );
};

const ContentContainer = styled("div")({
  padding: "2rem",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
});

const ImageContainer = styled("div")({
  width: "180px",
});

const StyledImage = styled("img")({
  width: "100%",
  height: "auto",
});

export default StateInfoGuide;
